import { useEffect, useRef, useState } from "react";
import "./CouponAppliedModal.scss";
import { useDispatch } from "react-redux";
import { validateCouponClearmsg } from "../../common/features/restaurant/restaurantAction";
import PercentageImage from '../../common/assets/svg/percentageimg.svg'
import Dollarimg from '../../common/assets/svg/dollarimg.svg'
import freeDeliveryimg from '../../common/assets/svg/freedeliveryimg.svg'
import freeItemimg from '../../common/assets/svg/freeitemimg.svg'
import { useSelector } from "react-redux";


const AUTO_CLOSE_MS = 2000;
const EXIT_ANIM_MS  = 300;   // must match ca-slide-down / ca-scale-out duration

const CouponAppliedModal = ({ open, onClose, couponDetails }: any) => {
  const dispatch = useDispatch();
  const [isExiting, setIsExiting] = useState(false);
  const [mounted, setMounted]     = useState(false);
  // openKey increments on every open so the CSS progress animation restarts.
  const [openKey, setOpenKey]     = useState(0);
  const firedRef   = useRef(false);
  const exitRef    = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onCloseRef = useRef(onClose);

  useEffect(() => { onCloseRef.current = onClose; }, [onClose]);

  // Mount instantly; unmount only after the exit animation finishes.
  useEffect(() => {
    if (open) {
      if (exitRef.current) clearTimeout(exitRef.current);
      setIsExiting(false);
      setMounted(true);
      setOpenKey(k => k + 1);
    } else if (mounted) {
      setIsExiting(true);
      exitRef.current = setTimeout(() => {
        setMounted(false);
        setIsExiting(false);
      }, EXIT_ANIM_MS);
    }
    return () => {
      if (exitRef.current) clearTimeout(exitRef.current);
    };
  }, [open]);

  const attributes =
    couponDetails && couponDetails?.attributes
      ? JSON.parse(couponDetails?.attributes)
      : null;
const offerType = couponDetails?.offerType || couponDetails?.offer_type;
  const upperOfferType = String(offerType || '').toUpperCase();
  const isFreeDelivery = upperOfferType === 'FREE_DELIVERY';
  const isFreeItem = upperOfferType === 'FREE_ITEM';

  const isPercentage =
    (offerType !== "FLAT" ) ;
  const offerRate = parseFloat(couponDetails?.offerRate) || parseFloat(couponDetails?.discount_value) || 0;



  // Max 3 digits before the decimal, 2 after. Also rounds to 2 decimals so
  // floating-point noise (e.g. 55.00000000000001) doesn't leak into the UI.
  const formatOfferNumber = (v: number) => {
    const capped = Math.min(Math.max(v, 0), 999);
    const rounded = Math.round(capped * 100) / 100;
    return Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(2);
  };
    const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );
  const totals = useSelector((state: any) => state.cart.totalDetails);

  // For order-level PERCENT offers with a maxDiscount cap, compute the actual
  // applied percentage from totals so the popup shows the real discount rate.
  const effectiveOfferRate = (() => {
    const isItemOffer = Boolean(couponDetails?.itemName);
    const maxCap = Number(couponDetails?.maxDiscount ?? couponDetails?.max_discount);
    if (!isPercentage || isItemOffer || !maxCap || !offerRate) return offerRate;
    const actualDiscount = parseFloat(
      totals?.orderTotals?.find((t: any) => t.code === '6' || t.code === '6.0')?.value || '0'
    );
    const itemSubTotal = parseFloat(
      totals?.orderTotals?.find((t: any) => t.code === '1' || t.code === '1.0')?.value || '0'
    );
    const isCapped = itemSubTotal > 0 && actualDiscount < (itemSubTotal * offerRate) / 100 - 0.01;
    if (isCapped && itemSubTotal > 0) {
      return Math.round((actualDiscount / itemSubTotal) * 10000) / 100;
    }
    return offerRate;
  })();

  const displayValue = isPercentage
    ? `${formatOfferNumber(effectiveOfferRate)} %`
    : `${
        restaurantDetails?.country === 'US'
          ? "$"
          : restaurantDetails?.country === "IN"
          ? "₹"
          : ""
      }${formatOfferNumber(offerRate)}`;

  useEffect(() => {
    if (!open) {
      firedRef.current = false;
      return;
    }

    firedRef.current = false;

    const closeTimer = setTimeout(() => {
      if (firedRef.current) return;
      firedRef.current = true;
      onCloseRef.current?.();
      dispatch(validateCouponClearmsg());
    }, AUTO_CLOSE_MS);

    return () => {
      clearTimeout(closeTimer);
    };
  }, [open]);

  if (!mounted) return null;

  const handleClose = () => {
    if (firedRef.current) return;
    firedRef.current = true;
    // Trigger exit animation; parent's onClose fires after it completes.
    setIsExiting(true);
    exitRef.current = setTimeout(() => {
      onClose();
      dispatch(validateCouponClearmsg());
    }, EXIT_ANIM_MS);
  };

  return (
    <div className={`ca-overlay${isExiting ? ' ca-overlay--exiting' : ''}`}>
      <div className={`ca-card${isExiting ? ' ca-card--exiting' : ''}`}>
        <button
          type="button"
          className="ca-close"
          aria-label="Close"
          onClick={handleClose}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L13 13M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {/* Image / badge */}
        {isFreeDelivery ? (
          <img src={freeDeliveryimg} alt="" className="ca-bogo-image"/>
        ) : isFreeItem ? (
          couponDetails?.freeItemImageUrl ? (
            <img
              src={couponDetails.freeItemImageUrl}
              alt={couponDetails?.freeItemName || ''}
              className="ca-bogo-image"
              onError={(e) => {
                const img = e.currentTarget;
                if (img.src !== freeItemimg) img.src = freeItemimg;
              }}
            />
          ) : (
            <img src={freeItemimg} alt=""  className="ca-bogo-image"/>
          )
        ) : couponDetails?.isBogo ? (
          couponDetails?.bogoItemImageUrl ? (
            <img
              src={couponDetails.bogoItemImageUrl}
              alt={couponDetails?.getItemName || ''}
              className="ca-bogo-image"
              onError={(e) => {
                const img = e.currentTarget;
                if (img.src !== freeItemimg) img.src = freeItemimg;
              }}
            />
          ) : (
            <img src={freeItemimg} alt="" className="ca-bogo-image"/>
          )
        ) : isPercentage ? (
          <img src={PercentageImage} alt="" className="ca-bogo-image"/>
        ) : (
          <img src={Dollarimg} alt="" className="ca-bogo-image"/>
        )}

        {/* Title */}
        {isFreeDelivery ? (
          <>
            <h2 className="ca-title">You Got Free Delivery</h2>
            <p className="ca-subtitle">Free delivery applied on this order</p>
          </>
        ) : isFreeItem ? (
          <>
            <h2 className="ca-title">You Got Free item</h2>
            <p className="ca-subtitle">Free item applied on this order</p>
          </>
        ) : couponDetails?.isBogoItemPopup ? (
          <>
            <h2 className="ca-title ca-bogo-title">
              You got { couponDetails?.discountLabel!=="FREE" ? `${couponDetails?.discountLabel} ` : 'free item' }
              { couponDetails?.discountLabel!=="FREE"? `for` :''}
              {couponDetails?.getItemName ? ` ${couponDetails.getItemName}` : ''}
            </h2>
            <p className="ca-subtitle">
              {couponDetails?.getItemName
                ? `${couponDetails.getItemName} added at ${couponDetails?.discountLabel?.toLowerCase?.() || 'free'} via this BOGO offer`
                : 'BOGO offer applied on this item'}.   
            </p>
          </>
        ) : couponDetails?.isBogo ? (
          <>
            <h2 className="ca-title ca-bogo-title">
              Buy {couponDetails?.buyQuantity} {couponDetails?.buyItemName} Get{' '}
              {couponDetails?.getQuantity} {couponDetails?.getItemName} free
            </h2>
            <p className="ca-subtitle">
              Buy one {couponDetails?.buyItemName?.toLowerCase?.() || 'item'}, get any{' '}
              {couponDetails?.getItemName?.toLowerCase?.() || 'item'} free, applied on this
              order
            </p>
          </>
        ) : couponDetails?.isItemOffer ? (
          <>
            <h2 className="ca-title">You Got {displayValue} Off</h2>
            <p className="ca-subtitle">
              {couponDetails?.itemName
                ? `Got ${displayValue} Off for ${couponDetails.itemName}`
                : `Got ${displayValue} Off applied on this order`}
            </p>
          </>
        ) : (
          <>
            <h2 className="ca-title">You got {displayValue} off</h2>
            <p className="ca-subtitle">
              Got {displayValue} Off applied on this order
            </p>
          </>
        )}

        {/* Auto-close progress bar — pure CSS animation, no JS state */}
        <div className="ca-progress-track">
          <div key={openKey} className="ca-progress-fill" />
        </div>
      </div>
    </div>
  );
};

export default CouponAppliedModal;
